export default __webpack_public_path__ + "static/media/login-background.f0b2e8a6.png";